import { render, staticRenderFns } from "./QuestionSingleSelect.vue?vue&type=template&id=7b61a935&"
import script from "./QuestionSingleSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSingleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports